// [HIGHCHARTS-10-MIGRATION-TAG]: Find and delete/clean all places like this once the migration ends
export const HIGHCHARTS_V10_VERSION = '10.3.3';
export const HIGHCHARTS_V8_VERSION = '8.1.2';
